import removeMd from 'remove-markdown'

/**
 * Strip markdown formatting from text while preserving content.
 *
 * @param text - Text with markdown formatting
 * @returns Plain text without markdown formatting
 */
export function stripMarkdownFormatting(text: string): string {
  if (!text) return ''

  return removeMd(text, {
    stripListLeaders: true, // Remove list markers (*, -, +, etc.)
    gfm: true, // Support GitHub Flavored Markdown
    useImgAltText: false // Don't use alt text for images
  })
}
